import type { GiantId } from '../../../../domain/ids/ids';
import { GIANT_IDS } from '../../../../domain/ids/ids';
import type { DeliveryPopupTail } from '../../components/atomic/dialog/delivery_popups/deliveryPopupLayout';
import { MAP_HEIGHT, MAP_WIDTH } from '../lands/landPositions';

export type DeliveryPopupPlacement = {
  giantId: GiantId;
  left: number;
  top: number;
  /** Tail-up chrome (sol, mu, serj, mona, duck, yetti, roza, svami). */
  tail?: DeliveryPopupTail;
};

/**
 * Positions from map.svg `#delivery_popups` groups,
 * scaled SVG (2222×1263) → world (9960×5662).
 * sol / mu / serj / mona / duck / yetti / roza / svami: tail-up; everyone else: default down.
 */
export const DELIVERY_POPUP_PLACEMENTS: readonly DeliveryPopupPlacement[] = [
  { giantId: 'sol', left: 2904.626, top: 1376.712, tail: 'up' },
  { giantId: 'mu', left: 6700.295, top: 1600, tail: 'up' },
  { giantId: 'serj', left: 1196.814, top: 2200.323, tail: 'up' },
  { giantId: 'mona', left: 1174.401, top: 3747.705, tail: 'up' },
  { giantId: 'duck', left: 1138.542, top: 4780.165, tail: 'up' },
  { giantId: 'factor', left: 4750, top: 3800 },
  { giantId: 'drakochi', left: 7370, top: 3429 },
  { giantId: 'willy', left: 6300, top: 2400 },
  { giantId: 'yetti', left: 4770, top: 2559, tail: 'up' },
  { giantId: 'svami', left: 3800, top: 3396, tail: 'up' },
  { giantId: 'roza', left: 8320, top: 2400, tail: 'up' },
] as const;

const PLACEMENT_BY_GIANT = new Map<GiantId, DeliveryPopupPlacement>(
  DELIVERY_POPUP_PLACEMENTS.map((placement) => [placement.giantId, placement]),
);

export function getDeliveryPopupPlacement(
  giantId: GiantId,
): DeliveryPopupPlacement | undefined {
  return PLACEMENT_BY_GIANT.get(giantId);
}

export function isDeliveryPopupPlacementInMapBounds(
  placement: DeliveryPopupPlacement,
): boolean {
  return (
    placement.left >= 0 &&
    placement.top >= 0 &&
    placement.left <= MAP_WIDTH &&
    placement.top <= MAP_HEIGHT
  );
}

export function allGiantIdsHaveDeliveryPopupPlacements(): boolean {
  return GIANT_IDS.every((giantId) => PLACEMENT_BY_GIANT.has(giantId));
}
